import { createSelector } from 'reselect';
import groupBy from 'lodash/groupBy';
import openConversationsSelector from './openConversations';
import allContactsSelector from './allContacts';

export default createSelector(
  openConversationsSelector,
  allContactsSelector,
  (
    /** Array[Objects] */ openConversations = [],
    /** Object */ allContacts = {}
  ) => {
    const consolidatedOpenConversations = openConversations.map(
      conversation => ({
        ...conversation,
        ...allContacts[conversation.jid],
      })
    );
    return groupBy(consolidatedOpenConversations, conversation => {
      if (conversation.pinned) {
        return 'pinned';
      }
      if (conversation.isMuted) {
        return 'mutedChannels';
      }
      return 'activeChats';
    });
  }
);



// WEBPACK FOOTER //
// ./src/selectors/consolidatedOpenConversations.js